import { render, staticRenderFns } from "./hotelsResults.vue?vue&type=template&id=6fba7845&scoped=true"
import script from "./hotelsResults.vue?vue&type=script&lang=js"
export * from "./hotelsResults.vue?vue&type=script&lang=js"
import style0 from "./hotelsResults.vue?vue&type=style&index=0&id=6fba7845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba7845",
  null
  
)

export default component.exports